export var DEFAULT_SEARCH_QUERY = '';